import type { VariationComponent } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
    checkMediaIntegrity,
} from "~utils/moduleIntegrity";

import { MEDIA_PRIORITY } from "./LineupContentCarouselBasic";

export default function integrityCheck({
    items,
}: VariationComponent): IntegrityStatus {
    const messages = checkItemArrayIntegrity(items);

    messages.push(...checkMediaIntegrity(items, MEDIA_PRIORITY));

    return messages;
}
